var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('vue-about-hero'),_c('vue-quote'),_c('vue-goals'),_c('vue-slider'),_c('vue-team'),_c('vue-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }